import { render } from "./slide-5.vue?vue&type=template&id=77e25d34&scoped=true"
import script from "./slide-5.vue?vue&type=script&lang=js"
export * from "./slide-5.vue?vue&type=script&lang=js"

import "./slide-5.vue?vue&type=style&index=0&id=77e25d34&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e25d34"]])

export default __exports__